/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSoHostCommandExecute = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-so-host-command-execute',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", { fillRule: "evenodd", clipRule: "evenodd" },
            React.createElement("path", { d: "M6.435 16.044a.86.86 0 0 0 1.178-.046l3.37-3.496-3.352-3.71a.86.86 0 0 0-1.176-.083.773.773 0 0 0-.086 1.124l2.38 2.634-2.362 2.451a.773.773 0 0 0 .048 1.126ZM11.167 15.422c0-.44.373-.797.833-.797h4.444c.46 0 .834.357.834.797 0 .44-.373.797-.834.797H12c-.46 0-.833-.357-.833-.797Z" }),
            React.createElement("path", { d: "M4.222 4h15.556C21.005 4 22 4.951 22 6.125v12.75C22 20.049 21.005 21 19.778 21H4.222C2.995 21 2 20.049 2 18.875V6.125C2 4.951 2.995 4 4.222 4Zm0 1.594a.544.544 0 0 0-.555.531v12.75c0 .293.248.531.555.531h15.556a.544.544 0 0 0 .555-.531V6.125a.544.544 0 0 0-.555-.531H4.222Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconSoHostCommandExecute.displayName = 'IconSoHostCommandExecute';
export default IconSoHostCommandExecute;
